module.exports = __webpack_public_path__ + "belgium.svg?49147ca6a0680fae34d8df40ae549457";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/belgium.svg
// module id = 108
// module chunks = 10